import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-leave-promo-detail',
  templateUrl: './leave-promo-detail.page.html',
  styleUrls: ['./leave-promo-detail.page.scss'],
})
export class LeavePromoDetailPage {

  constructor(private modalCtrl: ModalController) { }
  
  public onDismiss() {
    this.modalCtrl.dismiss(false);
  }
  
  public onConfirm() {
    this.modalCtrl.dismiss(true);
  }

}
